import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { RenderedService } from '../../rendered.service';

@Component({
    selector: 'app-base-scaffold',
    templateUrl: './base-scaffold.component.html',
    styleUrls: ['./base-scaffold.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
/*
base component for scaffold. extends other components into scaffold
 */
export class BaseScaffoldComponent implements OnInit {
  _value;
  @Input() item;
  @Input()
  set value(value) {
    if (this._value != value) {
      this._value = value;
      this.update();
    }
  }
  get value() {
    return this._value;
  }
  _info: any = {};
  @Input()
  set info(v) {
    this._info = v;
  }
  get info() {
    return this._info;
  }
  @Input() data;
  @Input() paramprefix;

  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService
  ) {}

  ngOnInit() {}
  update() {
    if (!this.cdr['destroyed']) {
      this.cdr.markForCheck();
    }
  }

  checkDisable() {
    return (
      this.renderedService.isDisabled(this.info.type) || this.item?.disabled
    );
  }

  redraw() {
    this.cdr.markForCheck();
  }
}
